export default __webpack_public_path__ + "static/media/redbook.c33f8263.jpg";